import React from "react";

import { Flex } from "theme-ui";

import { BASE_COLLAT } from "../../strings";
import { InfoMessage } from "../InfoMessage";
import { Approve } from "./Approve";

export const NoApproval: React.FC = () => {
  return (
    <Flex
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "64px",
        flex: 1,
        justifyContent: "space-between",
        height: "100%"
      }}
    >
      <InfoMessage title={"You haven't given your approval yet."}>
        To deposit collaterals into your vault, you need to convert {BASE_COLLAT} into ERC-20
        compatible Wrapped {BASE_COLLAT} (WASTR), and allow AstridDAO contracts to transfer your {}
        WASTR into the vault.
      </InfoMessage>

      <Approve />
    </Flex>
  );
};
